import { Component } from '@angular/core';
import { SwiperOptions } from 'swiper';
import { UtilidadesService } from '../utilidades/utilidades.servicios.index';
import { SWIPER_DATA_HEADER } from './inicio.constants';
import { FiltroProductosModel } from './../Modelo/Filtro_Productos.model';
import { GlobalService } from '../Servicios/global.service';

@Component({
	selector: 'app-inicio',
	templateUrl: './inicio.component.html',
	styleUrls: ['./inicio.component.scss', '../../css/Sitio.css' ]
})
export class InicioComponent {
	public showVideo = (Math.random() > 0.5) ? 1 : 2;

	public ConfiguracionSlider: SwiperOptions = {
		autoplay: {
			delay: 2500,
			disableOnInteraction: false
		  },
		init: true,
		speed: 2000,
		effect: 'fade',
		height: 500,
	};

	public ConfiguracionSliderService: SwiperOptions = {
		init: true,
		speed: 500,
		slidesPerView: 4,
		spaceBetween: 10,
		loop: true,
		navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
		},
		autoplay: {
		delay: 1500,
		disableOnInteraction: false,
		waitForTransition: true
		},
	};
	public swiperHeaderElement = SWIPER_DATA_HEADER;

	constructor(public Utilidades: UtilidadesService, public global: GlobalService,
		) {	}

	get swiperImagesUrls(): Array<string> {
		return [
			'assets/images/Encabezado_Servicios1.jpg', 
			'assets/images/Encabezado_Servicios2.jpg',
			'assets/images/Encabezado_Servicios3.jpg',
			'assets/images/Encabezado_Servicios4.jpg'
		];
	}

	trackBySwipeImages(index: number, item: any): number {
		return item;
	}

	searchProduct(): void {
		let Aux = this.global.FiltroProductos.TextoABuscar;
		this.global.FiltroProductos = new FiltroProductosModel();
		this.global.FiltroProductos.TextoABuscar = Aux;
		//this.Utilidades._menuAbierto = true;
		this.Utilidades.Navegar(["/Productos", encodeURI(this.global.FiltroProductos.TextoABuscar)]);
	}

	sho
}